import { apiGetEmoji } from '~/api/emoji'
import type {
  emojiInterface,
  emojiJsonInterface
} from '~/types/apiType/emojiType'

// 表情
export const useEmojiStore = defineStore({
  id: 'emoji',
  state: () => ({
    isPlaying: false, // 表情动画是否播放中(自己)
    emojiAnimationMap: {} as Record<number, emojiInterface>, // 记录哪个用户发送什么表情
    emojiJsonInfo: {} as emojiJsonInterface // 请求得到的表情信息
  }),
  actions: {
    /**
     * 发送表情通知im
     * @param faceId 表情id
     */
    sendEmoji(faceId: number) {
      if (this.isPlaying) return // 播放中就不再发送
      const socketStore = useSocketStore()
      const roomStore = useRoomStore()
      const userStore = useUserStore()
      const face = this.getEmojiInfo(faceId)
      if (userStore.userInfo.vipId < 2) {
        if (face?.isNobleFace && face.nobleId !== 5) {
          // 贵族表情需要vip大于等于2
          return
        }
      }
      const custom = {
        first: 9,
        second: 91,
        data: {
          data: [
            {
              faceId,
              isInvisible: Number(userStore.userInfo.isInvisible),
              nick: userStore.userInfo.nick,
              uid: userStore.userInfo.uid,
              vipDate: userStore.userInfo.vipDate,
              vipId: userStore.userInfo.vipId
            }
          ],
          experLevel: userStore.levelExperienceInfo.level,
          uid: userStore.userInfo.uid
        }
      }
      // 特殊表情添加字段
      if (face && face.resultCount > 0) {
        let index = 0
        const resultIndexes: number[] = []
        while (index < face.resultCount) {
          const randomNumber = Math.floor(
            Math.random() * (face.resultEndPos - face.resultStartPos + 1) +
              face.resultStartPos
          )
          resultIndexes.push(randomNumber)
          index++
        }
        custom.data.data[0]['resultIndexes'] = resultIndexes
      }
      const req_data = {
        custom: JSON.stringify(custom),
        member: JSON.stringify(socketStore.memberUserInfo),
        room_id: String(roomStore.roomInfo.roomId)
      }
      socketStore.sendMessage(req_data)
    },
    getEmojiInfo(faceId: number) {
      return (
        this.emojiJsonInfo.faces?.find((item) => item.id === faceId) || null
      )
    },
    /**
     * 初始化表情信息
     */
    async initEmojiInfo() {
      const res = await apiGetEmoji()
      try {
        const jsonString = cryptojs.decryptDES(
          (res.data.faceJson.json as string).replace(/[\r\n]/g, ''),
          cryptojs.keyOfKey
        )
        this.emojiJsonInfo = JSON.parse(jsonString)
        console.log('表情栏解析成功', this.emojiJsonInfo)
      } catch (error) {
        console.error('表情栏解析错误', error)
      }
    },
    /**
     * 获取表情图片url
     */
    getEmojiUrl(params: {
      pinyin: string
      id: number
      pos: number
      [key: string]: any
    }) {
      /**
       * 表情图片cdn基础链接 (为自己上传到七牛的图片)
       */
      const FACE_URL = 'https://res.coccolive.com/face-assets/'
      const { pinyin, id, pos } = params
      return `${FACE_URL}${pinyin}_${id}/${pinyin}_${id}_${pos}.png`
    },
    /**
     * 监听用户发送表情
     * @param data
     */
    onUserSendEmoji(data) {
      console.log('用户发送表情', data)
      console.log(this.emojiJsonInfo)
      if (!this.emojiJsonInfo?.faces) return
      const face = this.emojiJsonInfo.faces.find(
        (item) => item.id === data.data?.[0]?.faceId
      )

      if (face) {
        this.emojiAnimationMap[data.uid] = face

        const roomStore = useRoomStore()
        if (face.resultCount > 0) {
          setTimeout(() => {
            const resultIndexes = data.data?.[0]?.resultIndexes || []
            const faceUrls = resultIndexes.map((num) =>
              this.getEmojiUrl({ ...face, pos: num })
            )
            // 表情结果显示公屏
            roomStore.updateChatList('put', {
              id: data.timestamp,
              type: constant.ROOM_CHAT_TYPE.EMOJI_RESULT,
              content: '',
              nick: data.data?.[0]?.nick,

              faceUrls
            })
          }, 3000)
        }
      }
    },
    /**
     * 设置状态(自己)
     */
    setPlayStatus(value: boolean) {
      this.isPlaying = value
    },
    /**
     * 播放完成时移除表情信息
     */
    removeUserEmoji(uid: number) {
      uid && delete this.emojiAnimationMap[uid]
    }
  }
  // persist: {
  //   key: 'emojiStore',
  //   paths: []
  // }
})
